var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-md-8",attrs:{"fluid":""}},[_c('history-timeline')],1)}
var staticRenderFns = []

export { render, staticRenderFns }